module.exports = __webpack_public_path__ + "media/images/ln-img7-35bda54f75336615dbe5216181ab7eb9.png";